import { AppBar, Container, Toolbar } from 'components/common';
import { LogoIcon } from 'components/common/Icons';
import { FormattedMessage } from 'react-intl';
import { calculatorHeaderTabs } from './calculatorHeaderTabs';
import { Link } from 'react-router-dom';
import { PageURL } from 'router/pageURL';
import { useState } from 'react';
import { CalculatorDialog } from 'components/common';

export const CalculatorHeader = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const isTabActive = (link: string) => window.location.pathname.includes(link);

  return (
    <AppBar className={'bg-paper xs:shadow-lg relative md:shadow-none'}>
      {/* mobile view */}
      <Toolbar disableGutters variant={'dense'} className={'md:hidden'}>
        <Container maxWidth={'lg'} className={'flex items-center justify-between md:hidden'}>
          <LogoIcon className={'shrink-0 sm:ml-5 md:my-7 lg:ml-20'} width={'110'} height={'15'} />

          <div className={'flex items-center justify-center'}>
            <Link
              to={PageURL.SIGNUP}
              className={
                'text-main border-main font-satoshiMedium hover:bg-main mr-4 block rounded-full border border-solid px-4 py-1 text-xs font-medium no-underline transition duration-150 hover:text-white hover:ease-in'
              }
            >
              <FormattedMessage id={'calculator.header.signUp'} />
            </Link>

            <div onClick={() => setIsPopupOpen(prev => !prev)}>
              <div className={'bg-main border-main mx-1 mb-1 block h-px w-5 rounded border border-solid'}></div>
              <div className={'bg-main border-main mx-1 mb-1 h-0 w-5 rounded border border-solid'}></div>
              <div className={'bg-main border-main mx-1 h-0 w-5 rounded border border-solid'}></div>
            </div>
          </div>
        </Container>
        <CalculatorDialog open={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      </Toolbar>

      <Toolbar disableGutters className={'xs:hidden md:flex'}>
        <LogoIcon className={'shrink-0 sm:ml-5 md:my-7 lg:ml-20'} />

        <Container maxWidth={'lg'}>
          <div className={'flex grow sm:items-center'}>
            {calculatorHeaderTabs.map(({ link = '', textId, isNewTab = false }) => (
              <a
                target={isNewTab ? '_blank' : '_self'}
                rel={'noreferrer'}
                href={link}
                key={textId}
                className={`hover:text-main my-2 block px-2 text-base no-underline sm:text-center ${
                  isTabActive(link) ? 'text-main font-black' : 'text-ash font-satoshiMedium'
                }`}
              >
                <FormattedMessage id={textId} />
              </a>
            ))}
          </div>
        </Container>

        <div className={'flex grow-0 sm:mr-3 lg:mr-20'}>
          <Link
            to={PageURL.LOGIN}
            className={
              'text-main border-main font-satoshiMedium hover:bg-main mx-2 block rounded-full border border-solid px-4 py-1 text-base no-underline transition duration-150 hover:text-white hover:ease-in'
            }
          >
            <FormattedMessage id={'calculator.header.login'} />
          </Link>
          <Link
            to={PageURL.SIGNUP}
            className={
              'text-main bg-main border-main font-satoshiMedium hover:text-main mx-2 block whitespace-nowrap rounded-full border border-solid px-4 py-1 text-base text-white no-underline transition duration-150 hover:bg-transparent hover:ease-in'
            }
          >
            <FormattedMessage id={'calculator.header.signUp'} />
          </Link>
        </div>
      </Toolbar>
    </AppBar>
  );
};
